var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFi621995(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_926_4509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6657 0H4.63152C4.40152 0 4.21484 0.18668 4.21484 0.41668C4.21484 0.64668 4.40066 0.833359 4.63152 0.833359C5.88902 0.833359 7.0007 1.63504 7.3982 2.82586L7.47152 3.04836C7.52734 3.21918 7.68734 3.33504 7.86734 3.33504L17.499 3.33332C17.7207 3.33332 17.9515 3.36664 18.2273 3.43832C18.2623 3.4475 18.2973 3.45164 18.3323 3.45164C18.4232 3.45164 18.514 3.42164 18.5873 3.36496C18.6898 3.28578 18.749 3.16414 18.749 3.03496V2.08332C18.749 0.935 17.8148 0 16.6657 0Z",
    fill: "#5D616C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5013 4.16654H7.86879C7.33047 4.16654 6.85379 3.82322 6.68379 3.31236L6.61047 3.09068C6.32547 2.239 5.53129 1.6665 4.63379 1.6665H2.50129C1.35211 1.6665 0.417969 2.6015 0.417969 3.74982V13.7498C0.417969 14.8981 1.35215 15.8331 2.50129 15.8331H4.16797C4.39797 15.8331 4.58465 15.6465 4.58465 15.4165C4.58461 12.4299 7.01461 9.99986 10.0013 9.99986C12.988 9.99986 15.418 12.4299 15.418 15.4165C15.418 15.6465 15.6046 15.8332 15.8346 15.8332H17.5013C18.6505 15.8332 19.5846 14.8982 19.5846 13.7499V6.24986C19.5846 5.10154 18.6505 4.16654 17.5013 4.16654Z",
    fill: "#5D616C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 10.8335C7.47461 10.8335 5.41797 12.8893 5.41797 15.4168C5.41797 17.9443 7.47461 20.0002 10.0013 20.0002C12.528 20.0002 14.5846 17.9444 14.5846 15.4169C14.5846 12.8894 12.528 10.8335 10.0013 10.8335ZM12.7963 14.0452L9.46297 17.3785C9.38129 17.4593 9.27465 17.5002 9.16797 17.5002C9.06129 17.5002 8.95465 17.4594 8.87297 17.3785L7.20629 15.7118C7.04379 15.5493 7.04379 15.2851 7.20629 15.1226C7.36879 14.9601 7.63297 14.9601 7.79547 15.1226L9.16715 16.4943L12.2055 13.456C12.368 13.2935 12.6321 13.2935 12.7946 13.456C12.9571 13.6185 12.9588 13.8819 12.7963 14.0452Z",
    fill: "#5D616C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_926_4509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi621995);
export default __webpack_public_path__ + "static/media/fi_621995.4f1bd91bd7ab1b92b1fbf4a374c233be.svg";
export { ForwardRef as ReactComponent };